import React from 'react';
import Box from '@mui/material/Box';
import Logo from '../assets/logos-clever/logo-clever-cubo.svg';

const Loading = ({ loading, height, width }) => {
  if (!loading) return null;

  return (
    <>
      <div style={{ height: '100%', alignItems: 'center', justifyContent: 'center', display: 'flex' }}>
        <Box
          sx={{
            alignItems: 'center',
            justifyContent: 'center',
            display: 'flex',
            width: width || '150px',
            height: height || '150px',
            zIndex: 99,
          }}
        >
          <img src={Logo} alt="Imagem" style={{ width: '50%', animation: 'spin 2s linear infinite' }} />
        </Box>
      </div>
      <style>
        {`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}
      </style>
    </>
  );
};

export default Loading;
